import { render, staticRenderFns } from "./LabelInput.vue?vue&type=template&id=6f80027e&scoped=true&"
import script from "./LabelInput.vue?vue&type=script&lang=js&"
export * from "./LabelInput.vue?vue&type=script&lang=js&"
import style0 from "./LabelInput.vue?vue&type=style&index=0&id=6f80027e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f80027e",
  null
  
)

export default component.exports